/*
 * Tandy Club — tier/segment content gate. Two jobs, both keyed off the visitor's
 * resolved state ('logged-out' | 'not-member' | 'member' PLUS the exact Yotpo
 * vipTier.name, e.g. "Military Inner Circle"):
 *   1. Reveals each [data-tc-show-for] block whose comma-separated tier list
 *      matches; and hides each [data-tc-hide-for] block whose list matches (the
 *      inverse — e.g. hide the "get verified" banner from members already enrolled
 *      in a Military / First Responder tier). Those start visible.
 *   2. Highlights the member's column in the Loyalty Tiers row, mapping the eight
 *      Yotpo tiers onto the three primary columns (Community / Insider / Inner
 *      Circle) and tinting the border to that tier's badge color.
 * It consumes the SAME cached getCustomerDetails as the rest of the page
 * (window.TandyClub.customer) — no extra fetch and no second cold-load race. Live
 * data (points / activity / coupons) is NEVER gated here; only static per-tier
 * content. In the theme editor the section omits the hide CSS so every block
 * stays visible/selectable.
 */
(function () {
  'use strict';
  if (window.__tcGateInit) return; // loaded once per section; run once per page
  window.__tcGateInit = true;
  var blocks = [].slice.call(document.querySelectorAll('[data-tc-show-for]'));
  var hideBlocks = [].slice.call(document.querySelectorAll('[data-tc-hide-for]'));
  var tierCols = [].slice.call(document.querySelectorAll('.tc-tier[data-tc-tier-name]'));
  if (!blocks.length && !hideBlocks.length && !tierCols.length) return;

  function matches(attr, set) {
    var list = (attr || '').split(',');
    for (var i = 0; i < list.length; i++) { var w = list[i].trim().toLowerCase(); if (w && set[w]) return true; }
    return false;
  }
  function reveal(keys) {
    var set = {};
    keys.forEach(function (k) { var s = String(k == null ? '' : k).trim().toLowerCase(); if (s) set[s] = true; });
    // show-for: hidden by default (CSS), shown when the list matches.
    blocks.forEach(function (el) { el.hidden = !matches(el.getAttribute('data-tc-show-for'), set); });
    // hide-for: visible by default, hidden when the list matches.
    hideBlocks.forEach(function (el) { el.hidden = matches(el.getAttribute('data-tc-hide-for'), set); });
    document.body.classList.add('tc-resolved');
  }

  // The Loyalty Tiers row shows the three primary columns, but a member can be in
  // any of the eight Yotpo tiers — Military/First Responder/Business variants all
  // belong to a primary track. Map the tier name onto its column and flag it.
  function highlightTier(tier) {
    if (!tierCols.length || !tier) return;
    var name = String(tier).trim();
    var t = name.toLowerCase();
    var primary = t.indexOf('inner circle') > -1 ? 'inner circle'
      : t.indexOf('insider') > -1 ? 'insider'
        : t.indexOf('community') > -1 ? 'community' : '';
    if (!primary) return;
    tierCols.forEach(function (el) {
      if ((el.getAttribute('data-tc-tier-name') || '').trim().toLowerCase() !== primary) return;
      // Tint the highlight to this column's own badge color so it reads as "yours".
      var badge = el.querySelector('.tc-tier__name');
      if (badge) {
        var c = getComputedStyle(badge).backgroundColor;
        if (c) el.style.setProperty('--tc-tier-accent', c);
      }
      el.classList.add('is-current-tier');
      // Rename this column's badge to the member's EXACT tier (e.g. "Military
      // Inner Circle"), flanked by stars — so sub-tier members see the tier they
      // are really in, not just the primary column it maps to. Idempotent.
      if (badge && name && !badge.getAttribute('data-tc-named')) {
        badge.setAttribute('data-tc-named', '1');
        badge.textContent = '★ ' + name + ' ★';
      }
    });
  }

  function isMember(d) {
    if (!d || typeof d !== 'object') return false;
    if (d.isOptIn === true || d.isMember === true) return true;
    if (typeof d.pointsBalance === 'number' && d.pointsBalance > 0) return true;
    if (d.actionHistoryItems && d.actionHistoryItems.length) return true;
    if (d.pointRedemptions && d.pointRedemptions.length) return true;
    if (d.vipTier && d.vipTier.name) return true;
    return false;
  }

  // Editor/QA preview: ?tc_segment=<tier or state> forces a state so each panel
  // can be verified without a real account in that tier. The member keys are
  // included so member-gated panels also show.
  var m = (location.search || '').match(/[?&]tc_segment=([^&]+)/);
  if (m) {
    var forced = decodeURIComponent(m[1]).replace(/\+/g, ' ');
    var loose = forced === 'logged-out' || forced === 'not-member';
    // Preview a member tier as "no birthday yet" so the birthday prompt is visible.
    reveal(loose ? [forced] : ['member', forced, 'member-nobirthday']);
    if (!loose) highlightTier(forced);
    return;
  }

  // In the theme editor the hide CSS is not emitted, so all blocks are visible.
  if (window.Shopify && window.Shopify.designMode) return;

  // Logged out is known server-side — resolve instantly, no SDK wait.
  if (!window.tcLoggedIn) { reveal(['logged-out']); return; }

  var TC = window.TandyClub;
  if (!TC || typeof TC.customer !== 'function') { reveal(['not-member']); return; }

  function resolveVisitor(d) {
    if (isMember(d)) {
      var tier = d && d.vipTier && d.vipTier.name ? String(d.vipTier.name) : '';
      var keys = ['member', window.tcHasBirthday ? 'member-hasbirthday' : 'member-nobirthday'];
      if (tier) keys.push(tier);
      reveal(keys);
      highlightTier(tier);
    } else {
      reveal(['not-member']);
    }
  }
  TC.customer().then(resolveVisitor).catch(function () { reveal(['not-member']); });
  // Re-resolve when the SDK module broadcasts late-arriving member data.
  document.addEventListener('tandyclub:customer-updated', function (e) { resolveVisitor(e.detail); });
})();
